import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import EventTable from '../layouts/components/events/EventTable';
import Toolbar from '../layouts/components/events/Toolbar';
import EventItem from '../layouts/components/events/EventItem';
import {AlertEventObject, BookmakerData, EventSettingsObject, EventsStoredObjects, User} from '../@types/response';
import {getBookmakers} from '../store/selectors/getBookmakers';
import EventDetailsModal from '../layouts/components/modals/EventDetailsModal';
import {getMonitors} from '../store/selectors/event/getMonitors';
import {GetInitAction} from '../store/actions/event/GetInitAction';
import getClient from '../store/selectors/getClient';
import {keySearch, sortEvent} from "../store/utils/eventUtils";
import {AppDispatch} from "recharts/types/state/store";
import {getFixtures} from "../store/selectors/getFixtures";
import {getSettings} from "../store/selectors/event/getSettings";

const Events: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    const fixtures: EventsStoredObjects = useSelector(getFixtures);
    const monitors: AlertEventObject[] = useSelector(getMonitors);
    const bookmakers: BookmakerData = useSelector(getBookmakers);
    const client: undefined | User = useSelector(getClient);
    const settings: EventSettingsObject = useSelector(getSettings);

    const sortedMonitors = useMemo(() =>
                    [...monitors].sort((a, b) => sortEvent(a, b, fixtures, settings)),
            [monitors, fixtures, settings]
    );

    const [search, setSearch] = useState<string>('')

    useEffect(() => {
        dispatch(GetInitAction(client?.id || ''));
        document.title = 'EVENTS - OddMonitor';
    }, []);

    if (!Object.keys(bookmakers).length) {
        return <React.Fragment>
            <div
                    id='toolbar-events'
                    className='bg-toolbar-bgMain border-b border-toolbar-borderBottom fixed top-0 right-0 flex items-end justify-around w-full z-10'
            >
                <Toolbar
                        search={search}
                        setSearch={setSearch}
                />
            </div>
            <div className='mt-16'>
                <EventTable/>
            </div>
            <div>Loading</div>
        </React.Fragment>;
    }

    return (
            <div>
                <div
                        id='toolbar-events'
                        className='bg-toolbar-bgMain border-b border-toolbar-borderBottom fixed top-0 right-0 flex items-end justify-around w-full z-10'
                >
                    <Toolbar
                            search={search}
                            setSearch={setSearch}
                    />
                </div>
                <div className='mt-16 mx-4'>
                    <EventTable>
                        {sortedMonitors
                                .filter(alert => keySearch(search.toLowerCase(), fixtures[alert.id]))
                                .filter(alert => client?.client == null || client.client === alert.bookmakerId)
                                .map((alert: AlertEventObject, idx: number) => (
                                        <EventItem alert={alert} key={`${alert.id}x${idx}`} event={fixtures[alert.id]}/>
                                ))}
                    </EventTable>
                </div>

                <EventDetailsModal/>
            </div>
    );
}

export default Events;
